import { createFileRoute, useLocation, useRouter } from '@tanstack/react-router';
import { SearchPage } from '../../../operacoes/busca/search-page.tsx';
import { searchIdOf } from '../../../operacoes/shared/search-url.ts';

// The searched id is read raw from the history's URL, not through `validateSearch` nor the
// location's `searchStr`: the router parses each search value as JSON first (and writes
// `searchStr` back from that), which would turn a trace id of only digits (or `4e12…`) into a
// number, losing digits, and `true` into a boolean the route would refuse with its error screen.
// Power normalizes the text, or refuses it with the screen's own "Id inválido".
export const Route = createFileRoute('/operacoes/busca')({
  component: SearchRoute,
});

function SearchRoute(): JSX.Element {
  const router = useRouter();
  // Re-read on every navigation; the history keeps the query as the URL holds it.
  const searchStr = useLocation({ select: () => router.history.location.search });
  return <SearchPage id={searchIdOf(searchStr)} />;
}
